import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from 'src/app/core/auth/permissions.service';
import { Permission } from 'src/app/core/clients/generated/client';

@Directive({
  selector: '[appShowIfOne]'
})
export class ShowIfOneDirective {

  private hasView = false;

  constructor(private templateRef:TemplateRef<any>, private viewContainerRef:ViewContainerRef, private permissionService:PermissionsService) { }

  @Input() set appShowIfOne(permissions:Permission|Permission[]) {

    const isAuthorized = this.permissionService.hasOnePermission(permissions);
    if(isAuthorized && !this.hasView){
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isAuthorized && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  }
}